import { render, staticRenderFns } from "./ModalCompanyReportAccess.vue?vue&type=template&id=255baaa2"
import script from "./ModalCompanyReportAccess.vue?vue&type=script&lang=js"
export * from "./ModalCompanyReportAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports